import React from "react"
import styled, { css } from "styled-components"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  span {
    color: white;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    ${below.mobile`
    line-height: 20px;
  `}
  }
`

const Licensing = props => {
  const scenario = () => {
    // If the MB isn't listed in GA use default licensing format
    if (!props.licenses.includes("GA") && !props.licenses.includes("GA TAO")) {
      return "default"
    }
    // If the MB is only licensed in GA
    else if (props.licenses.length < 2) {
      if (props.licenses.includes("GA")) {
        return "ga-standard"
      } else {
        return "ga-tao"
      }
    }
    // If the MB is licensed in GA and other states
    else {
      if (props.licenses.includes("GA")) {
        return "ga-plus-standard"
      } else {
        return "ga-plus-tao"
      }
    }
  }

  switch (scenario()) {
    default:
      return (
        <Wrapper>
          <span>
            {`Licensed in `}
            {props.licenses.map(licensedState => (
              <span key={licensedState}>
                {`${licensedState}${
                  props.licenses.length === 2 &&
                  props.licenses.indexOf(licensedState) <
                    props.licenses.length - 1
                    ? " & "
                    : ""
                }${
                  props.licenses.length > 2 &&
                  props.licenses.indexOf(licensedState) <
                    props.licenses.length - 1
                    ? ", "
                    : ""
                }`}
              </span>
            ))}
          </span>
        </Wrapper>
      )
    case "ga-standard":
      return (
        <Wrapper>
          <span>{`Georgia Residential Mortgage Licensee # ${props.stateSpecificLicense}`}</span>
        </Wrapper>
      )
    case "ga-tao":
      return (
        <Wrapper>
          <span>{`GA Temporary Authority`}</span>
        </Wrapper>
      )
    case "ga-plus-standard":
      return (
        <Wrapper>
          <span>
            {`Licensed in `}
            {props.licenses.map(licensedState => (
              <span key={licensedState}>
                {`${
                  licensedState === "GA"
                    ? "GA # " + props.stateSpecificLicense
                    : licensedState
                }${
                  props.licenses.length === 2 &&
                  props.licenses.indexOf(licensedState) <
                    props.licenses.length - 1
                    ? " & "
                    : ""
                }${
                  props.licenses.length > 2 &&
                  props.licenses.indexOf(licensedState) <
                    props.licenses.length - 1
                    ? ", "
                    : ""
                }`}
              </span>
            ))}
          </span>
        </Wrapper>
      )
    case "ga-plus-tao":
      return (
        <Wrapper>
          <span>
            {`Licensed in `}
            {props.licenses.map(licensedState => (
              <span>
                {`${licensedState === "GA TAO" ? "" : licensedState}${
                  props.licenses.length > 2 &&
                  licensedState !== "GA TAO" &&
                  props.licenses.indexOf(licensedState) <
                    props.licenses.length - 1
                    ? ", "
                    : ""
                }`}
              </span>
            ))}
            <br />
            GA Temporary Authority
          </span>
        </Wrapper>
      )
  }
}

export default Licensing
